import { EC_SLA_HOURS, HOURS_IN_A_DAY } from '@src/pages/ExpertCheck/constants'
import wtaiApi from '@src/utils/http-clients/wtaiApi'

export const uploadPaper = async (file: File) => {
  const formData = new FormData()
  formData.append('file', file)
  const {
    data: { id },
  } = await wtaiApi.post('/zoho/upload/v1/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return id
}

export const createFeedbackDate = (
  turnaroundDays: number = EC_SLA_HOURS / HOURS_IN_A_DAY
) => {
  const time = new Date()
  time.setDate(time.getDate() + turnaroundDays)
  return time.toLocaleDateString(undefined, {
    weekday: 'long',
    month: 'short',
    day: 'numeric',
  })
}



// WEBPACK FOOTER //
// ./src/state/expertcheck/utils.ts